import { get, writable } from "svelte/store"
import { location, login, rerenderSteps } from "./store"
import { spaNavigate } from "./actions"
import { get as _get } from "lodash"

import Cryptcha from "cryptcha"
import { cryptchaSiteId } from "../../../api/hooks/config-client"
import { postDBEntry } from "../api"
import { getEventCallbacks } from "./eventBus"

type filterMap = { [key: string]: string[] }
type keyMapping = { [key: string]: string }

export function applyFilterFromHash(
    hash: string,
    keys: keyMapping,
    items: any[],
    callback?: () => void
): { filteredItems: any[]; newFilter?: filterMap } {
    let filteredItems: any[] = []

    if (items?.length && hash) {
        const hashParts = hash.replace(/^#/, "").split("&")
        const newFilter: { [key: string]: string[] } = {}
        Object.keys(keys).forEach((key) => {
            newFilter[key] = []
        })
        let doFiltering = false
        hashParts.forEach((part) => {
            const [key, value] = part.split("=")
            if (key in newFilter) {
                newFilter[key] = value.split(",")
                if (newFilter[key].length) {
                    doFiltering = true
                }
            }
        })

        if (doFiltering && callback) {
            callback()
        }

        filteredItems = doFiltering
            ? items.filter((item) => {
                  let _filtered = true
                  Object.keys(newFilter).forEach((key) => {
                      const vKey = keys[key]
                      const itemVal = _get(item, vKey)
                      if (vKey && newFilter[key].length) {
                          _filtered =
                              _filtered &&
                              newFilter[key].some(
                                  (v) => itemVal == v || (Array.isArray(itemVal) && itemVal.includes(v))
                              )
                      }
                  })
                  return _filtered
              })
            : [...items]
        // console.log("doFiltering", filteredItems)

        return { filteredItems, newFilter }
    } else {
        return { filteredItems: [...items] }
    }
}

export function filter2Hash(filter: filterMap, navigate?: boolean): string {
    const urlHash = Object.keys(filter)
        .map((key) => {
            return filter[key].length ? key + "=" + filter[key].join(",") : ""
        })
        .filter((v) => v)
        .join("&")

    if (navigate) {
        const currentHash = get(location).hash.replace(/^#/, "")
        if (currentHash !== urlHash) {
            if (urlHash) {
                spaNavigate(get(location).path + "#" + urlHash, { replace: true })
            } else {
                spaNavigate(get(location).path, { replace: true })
            }
        }
    }
    return urlHash
}

export const cryptchaSolution = writable("")
export const cryptchaSolutionId = writable("")
let cryptcha: Cryptcha
let cryptchaTarget: HTMLDivElement
export async function initCryptcha(target: HTMLElement) {
    if (!cryptcha) {
        // create new instance
        cryptchaTarget = document.createElement("div")
        cryptcha = new Cryptcha({
            siteId: cryptchaSiteId,
            target: cryptchaTarget,
            baseUrl: "https://cryptcha.webmakers.de/api/command",
            log: false,
            autoSolve: true,
            onSolved({ solution, solutionId }) {
                cryptchaSolution.set(solution)
                cryptchaSolutionId.set(solutionId)
            },
        })
    }

    if (target) {
        target.innerHTML = ""
        target.appendChild(cryptchaTarget)
    }
}

export function resetCryptcha() {
    cryptcha = null
    cryptchaSolution.set("")
    cryptchaSolutionId.set("")
}

export async function addTaskToOrder(orderId: string) {
    let loginObj = get(login)
    const res = await postDBEntry("task", {
        completedSteps: [],
        taskType: "oilSpillRemoval",
        orderId: orderId,
        generalDetails: {
            shortDescription: "",
            description: "",
        },
        meta: {
            createdBy: {
                id: loginObj.user.id,
                name: `${loginObj.user.firstName} ${loginObj.user.lastName}`,
            },
            editedBy: [],
        },
    })
    const taskId = res.data.data.id
    spaNavigate(`/order/${orderId}/task/${taskId}`)
}
export function downloadFile(fileData: BlobPart, fileName: string, mimeType = "application/octet-stream") {
    const blob = new Blob([fileData], { type: mimeType })
    const src = URL.createObjectURL(blob)

    const a = document.createElement("a")
    a.href = src
    a.download = fileName // Use the provided file name
    document.body.appendChild(a)
    a.click()
    document.body.removeChild(a)

    URL.revokeObjectURL(src) // Clean up the object URL
}
export function changeStep(stepIndex: number) {
    const url = new URL(window.location.href)
    url.searchParams.set("selectedStep", String(stepIndex + 1))
    const urlStringFormat = url.toString()
    if (getEventCallbacks("navigate")) {
        let callbacks = Object.values(getEventCallbacks("navigate"))
        for (let i = 0; i < callbacks?.length; i++) {
            if (callbacks[i](urlStringFormat, null) === false) return
        }
    }
    window.history.pushState(null, "", urlStringFormat)
    rerenderSteps.set(Math.random())
}
